export default __webpack_public_path__ + "static/media/woman1.f1809640.gif";